module.exports = __webpack_public_path__ + "img/wheelExampleOutlined.720976b3.svg";